import PropTypes from 'prop-types'
import React from 'react'
import cn from 'utils/tailwind/cn'

import { useFormAppearance } from '@/hooks/useFormAppearance'

function Checkbox({
  disabled,
  onChange,
  checked,
  label,
  labelClassName,
  className,
  noMargin,
  useDisplayBlock,
  hasError,
  willShowNotAllowedCursor,
  children,
  ...props
}) {
  const handleChange = disabled ? () => {} : (e) => onChange(e.target.checked)
  const { hasQuestionColor } = useFormAppearance()
  return (
    <label
      className={cn(
        'mb-0',
        !noMargin && 'mb-[1px]',
        !useDisplayBlock && 'flex',
        'h-full py-1',
        className
      )}
    >
      <input
        checked={checked}
        className={cn('form-checkbox h-5 w-5 rounded border text-blue-600', {
          'cursor-not-allowed bg-gray-100':
            disabled && willShowNotAllowedCursor,
          'border-2 border-red-500': hasError,
        })}
        disabled={disabled}
        onChange={handleChange}
        type="checkbox"
        {...props}
      />
      <span
        className={cn(
          hasQuestionColor && 'question-text',
          'ml-2 text-left text-sm leading-5 text-gray-700',
          labelClassName
        )}
      >
        {label || children}
      </span>
    </label>
  )
}

Checkbox.defaultProps = {
  onChange: () => {},
  disabled: false,
  checked: false,
}

Checkbox.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
}

export default React.memo(Checkbox)
